<template>
	<div class="section pride-chosen-families-container" ref=chosenfamilies>
		<div class="pride-inner">
			<h3 v-html="chosenFamilies.COPY"></h3>
		</div>
	</div>
</template>

<script>

	// import inViewMixin from "../../../src/mixins/inViewMixin";

	export default {
			name: "pride-chosen-families",
			// mixins: [inViewMixin],
			props: {
				chosenFamilies: {
					type: Object,
				}
			},
			data(){
			return{
				observer : null
			}
		},
		mounted(){
			this.observer = new IntersectionObserver(this.onIntersect, {
				root: null,
				rootMargin: '0px 0px 0px 0px',
				threshold: .5,
			})

			this.observer.observe(this.$el)
			},
			destroyed(){
				this.observer.disconnect()
				this.observer = null
			},
			methods: {
				onIntersect(event) {
					const chosenfamilies = this.$refs.chosenfamilies;
					const isIntersecting = event.find((entry) => {
						return entry.isIntersecting
					})
					if (isIntersecting) {
						this.$emit('intersect', event)
						// console.log("chosen family intersecting")
						chosenfamilies.querySelectorAll('h3 > span').forEach(el => {
							el.classList.add("active");
						});
					}
				},				
			}
	}

</script>
<style lang='scss'>

	.pride-chosen-families-container {
		
		background-color: #000000;

		@media (min-width: 768px) {
			min-height: 615px;
		}

		span {
			color: #000000;
		}

		.pride-inner {
			padding: 2em 0;
		}

		.header_ani {
			animation: move 1s forwards;
			animation-delay: 100ms;
		}

		.red-txt {
			text-shadow: 0 0 2px #eb1c24, 0 0 2px #eb1c24, 0 0 2px #eb1c24, 0 0 2px #eb1c24;
			&.active {
				animation: red-txt-animation .5s .5s forwards;
			}
		}

		.orange-txt {
			text-shadow: 0 0 2px #f68c1e, 0 0 2px #f68c1e, 0 0 2px #f68c1e, 0 0 2px #f68c1e;
			&.active {
				animation: orange-txt-animation .5s .6s forwards;
			}
		}

		.yellow-txt {
			text-shadow: 0 0 2px #fae72b, 0 0 2px #fae72b, 0 0 2px #fae72b, 0 0 2px #fae72b;
			&.active {
				animation: yellow-txt-animation .5s .7s forwards;
			}
		}

		.green-txt {
			text-shadow: 0 0 2px #16b036, 0 0 2px #16b036, 0 0 2px #16b036, 0 0 2px #16b036;
			&.active {
				animation: green-txt-animation .5s .8s forwards;
			}
		}

		.blue-txt {
			text-shadow: 0 0 2px #3e62b0, 0 0 2px #3e62b0, 0 0 2px #3e62b0, 0 0 2px #3e62b0;
			&.active {
				animation: blue-txt-animation .5s .9s forwards;
			}
		}

		.purple-txt {
			text-shadow: 0 0 2px #6d459b, 0 0 2px #6d459b, 0 0 2px #6d459b, 0 0 2px #6d459b;
			&.active {
				animation: purple-txt-animation .5s 1s forwards;
			}
		}

		.pink-txt {
			text-shadow: 0 0 2px #f775cd, 0 0 2px #f775cd, 0 0 2px #f775cd, 0 0 2px #f775cd;
			&.active {
				animation: pink-txt-animation .5s 1.1s forwards;
			}
		}

		.cyan-txt {
			text-shadow: 0 0 2px #02b9db, 0 0 2px #02b9db, 0 0 2px #02b9db, 0 0 2px #02b9db;
			&.active {
				animation: cyan-txt-animation .5s 1.2s forwards;
			}
		}

		.brown-txt {
			text-shadow: 0 0 2px #8d5e3b, 0 0 2px #8d5e3b, 0 0 2px #8d5e3b, 0 0 2px #8d5e3b;
			&.active {
				animation: brown-txt-animation .5s 1.3s forwards;
			}
		}

		.red-2-txt {
			text-shadow: 0 0 2px #eb1c24, 0 0 2px #eb1c24, 0 0 2px #eb1c24, 0 0 2px #eb1c24;
			&.active {
				animation: red-txt-animation .5s 1.4s forwards;
			}
		}

		.orange-2-txt {
			text-shadow: 0 0 2px #eb1c24, 0 0 2px #eb1c24, 0 0 2px #eb1c24, 0 0 2px #eb1c24;
			&.active {
				animation: orange-txt-animation .5s 1.5s forwards;
			}
		}

		.yellow-2-txt {
			text-shadow: 0 0 2px #fae72b, 0 0 2px #fae72b, 0 0 2px #fae72b, 0 0 2px #fae72b;
			&.active {
				animation: yellow-txt-animation .5s 1.6s forwards;
			}
		}

		.green-2-txt {
			text-shadow: 0 0 2px #16b036, 0 0 2px #16b036, 0 0 2px #16b036, 0 0 2px #16b036;
			&.active {
				animation: green-txt-animation .5s 1.7s forwards;
			}
		}

		.purple-2-txt {
			text-shadow: 0 0 2px #6d459b, 0 0 2px #6d459b, 0 0 2px #6d459b, 0 0 2px #6d459b;
			&.active {
				animation: purple-txt-animation .5s 1.8s forwards;
			}
		}

		@keyframes move {
			from {
				transform: translateY(100%);
			}
			to {
				transform: translateY(0%);
			}
		}

	}
	
	@keyframes red-txt-animation {
    0% {color:#000000;}
		100%{color:#eb1c24;text-shadow: none;}
	}

	@keyframes orange-txt-animation {
    0% {color:#000000;}
		100%{color:#f68c1e;text-shadow: none;}
	}

	@keyframes yellow-txt-animation {
    0% {color:#000000;}
		100%{color:#fae72b;text-shadow: none;}
	}

	@keyframes green-txt-animation {
    0% {color:#000000;}
		100%{color:#16b036;text-shadow: none;}
	}

	@keyframes blue-txt-animation {
    0% {color:#000000;}
		100%{color:#3e62b0;text-shadow: none;}
	}

	@keyframes purple-txt-animation {
    0% {color:#000000;}
		100%{color:#6d459b;text-shadow: none;}
	}

	@keyframes pink-txt-animation {
    0% {color:#000000;}
		100%{color:#f775cd;text-shadow: none;}
	}

	@keyframes cyan-txt-animation {
    0% {color:#000000;}
		100%{color:#02b9db;text-shadow: none;}
	}

	@keyframes brown-txt-animation {
    0% {color:#000000;}
		100%{color:#8d5e3b;text-shadow: none;}
	}

</style>



// WEBPACK FOOTER //
// src/components/pride/PrideChosenFamilies.vue